import { render, staticRenderFns } from "./AppointmentNotificationSettings.vue?vue&type=template&id=4e907fe1"
import script from "./AppointmentNotificationSettings.vue?vue&type=script&lang=js"
export * from "./AppointmentNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports